import React, { useState, useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useParams, useHistory, Link } from "react-router-dom";

import * as actions from "./_redux/Actions";

import { useSubheader } from "../../../_metronic/layout";
import { NotificationContainer, NotificationManager } from "react-notifications";
import { Multiselect } from "multiselect-react-dropdown";
import {
  Card,
  CardBody,
  CardHeader,
  ModalProgressBar,
  DatePickerField,
  TimePickerField,
  Select,
  Input,
} from "../../../_metronic/_partials/controls";
import DataTable from "../../components/DataTable";
import { Formik, Form, Field, FieldArray } from "formik";
import { Col, Row } from "react-bootstrap";
import moment from "moment";

import * as UIHelpers  from "../../components/UIHelpers";

import { Accordion, Button } from "react-bootstrap";
import sorter from "sort-nested-json";
import * as columnFormatters from "../../components/column-formatters";
import {imageUrl} from "../../components/UIHelpers";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

import TournamentSummeryDetails from "./TournamentSummeryDetails";

import { teamColumn } from "./teamColumn";

export const initialFilter = {
  sort: "desc", // asc||desc
  sortBy: "createdAt",
  skip: UIHelpers.skip,
  limit: UIHelpers.limit,
  page: UIHelpers.page
};

const TournamentTeams = (props) => {
  const { id } = useParams();
  let history = useHistory();
  const suhbeader = useSubheader();
  const dispatch = useDispatch();

  const [rows, setRows] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [allColumns, setAllColumns] = useState(teamColumn);
  const [cols, setCols] = useState(teamColumn);
  const [sortDirection, setSortDirection] = useState([]);
  const [showSortArrow, setShowSortArrow] = useState([]);
  const [searchApply, setSearchApply] = useState(false);
  const [filter, setFilter] = useState(initialFilter);

  const [collasibleRowData, setCollasibleRowData] = useState({});

  const { currentState } = useSelector(
    (state) => ({ currentState: state.tournamentsSlice }),
    shallowEqual
  );
  const {
    actionsLoading,
    tournamentForEdit,
    countryDropdownList,
    currencyDropdownList,
    listLoading,
    contestUsers
  } = currentState;

  useEffect(() => {
    var tampFilter = { ...filter };
    dispatch(actions.fetchSingle(id));
    tampFilter.id = id;
    setFilter(tampFilter);
    dispatch(actions.fetchContestUsersList(tampFilter));
  }, [id, dispatch]);

  const DataTablePaginationAPICall = (values) => {
    setSearchApply(true);
    var tampFilter = { ...filter };

    // if (values?.skip) {
    tampFilter.skip = values.skip;
    tampFilter.page = values.page;
    // }
    if (values?.limit) {
      tampFilter.limit = values.limit;
    }
    
    tampFilter.pagination = {
      pageNo: values.page,
      recordPerPage: values.limit,
      sortBy: "createdAt",
      sortDirection: "asc",
    };

    setFilter(tampFilter);
    // setCount(count + 1);

    tampFilter.id = id;

    if (!listLoading) {
      dispatch(actions.fetchContestUsersList(tampFilter));
    }
  };

  const insert = (arr, index, newItem) => [
    // part of the array before the specified index
    ...arr.slice(0, index),
    // inserted item
    newItem,
    // part of the array after the specified index
    ...arr.slice(index)
  ]

  useEffect(() => {
    let temp1 = [];
    temp1.push(
      {
        dataField: "plusMinusIcon",
        text: "+",
        sort: false,
        show: true,
        format: {
          type: 'collasibleDataIcon',
          formatfunction: {
            onClickIcon: onClickIcon,
            returnCollasibleData: returnCollasibleData,
          }
        },
      },
    );


    allColumns.map((item, index) => {
      if (item?.show === true) {
        temp1.push(item);
      }
    });

    // if(temp1.requestStatus=="canceled"){
    temp1.push(
      {
        dataField: "action",
        text: "Actions",
        sort: false,
        show: true,
        format: {
          type: 'action',
          style: {
            width: "150px",
          },
          formatfunction: {
            approvedTeamItem: approvedTeamItem,
            rejectTeamItem: rejectTeamItem,
            deleteItem: deleteItem
          }
        },
      }
    );

    //}

    setAllColumns(temp1);
  }, [teamColumn]);

  const approvedTeamItem = (row_value) => {
    dispatch(actions.acceptTournamentUsersList(row_value._id)).then((sucess) => sucess ? getUserList() : null);
  }

  const onClickIcon = (row_value) => {
    console.log("row_value", row_value)
  }

  const rejectTeamItem = (row_value) => {
    dispatch(actions.rejectTournamentUsersList(row_value._id)).then((sucess) => sucess ? getUserList() : null);
  }

  const deleteItem = (row_value) => {
    if(row_value?.allocateCount && row_value?.allocateCount > 0)
    {
      NotificationManager.error('This user is already allocated.', 'Error');
    }
    else
    {
      dispatch(actions.deleteStatusTournamentUsersList(row_value._id)).then((sucess) => sucess ? getUserList() : null);
    }
  }

  const returnCollasibleData = (row_value, collasible_row_data) => {
    let data = collasible_row_data[row_value?.phone];
    if (data) {
      return (
        <div className="d-flex flex-column flex-grow-1 pr-8 bg-secondary">
          <div className="d-flex flex-wrap">
            <table className="w-100">
              <tr>
                <th>User Id</th>
                <th>Phone</th>
                <th>Player Name</th>
                <th>Player In Game Name</th>
                <th>Character Id</th>
                <th>Discord Id</th>
              </tr>
              {row_value.teamDetails.map((teamValue) =>
                <tr>
                  <td>{teamValue?.user_saas_id}</td>
                  <td>{teamValue?.teamUserData?.phoneCode}{" "}{teamValue?.teamUserData?.phone}</td>
                  <td>{teamValue?.isCaptain ? "(C)" : "(O)" }{" "}{teamValue?.playerName}</td>
                  <td>{teamValue?.playerInGameName}</td>
                  <td>{teamValue?.charId}</td>
                  <td>{teamValue?.discordId}</td>
                </tr>
              )}
            </table>
          </div>
        </div>
      )
    }
    else {
      return (
        <div className="row mt-10 pb-10">
          <div className="spinner spinner-dark spinner-lg m-auto"></div>
        </div>
      )
    }
  }

  const reloadLocation = () => {
    window.location.reload();
  };
  const getUserList = () => {
    var tampFilter = { ...filter };
    tampFilter.id = id;
    setFilter(tampFilter);
    dispatch(actions.fetchContestUsersList(tampFilter));
  };

  const CurrencyIcoon = ({ item }) => {
    console.log(item)
    return (
      <span className="text-dark-50 font-weight-bold">
        {item.currency && item.currency.img ? (
          <img
            className="currency"
            // src={`${process.env.REACT_APP_UPLOADED_FILE_URL}/${item.currency &&
            //   item.currency.img.default}`}
              src={imageUrl(item.currency && item.currency.img.default)}
            alt="currency"
          />
        ) : (
          <span className="text-dark-50 font-weight-bold">₹</span>
        )}
      </span>
    );
  };

  const onClickSortCol = (key) => {
    let show_sort_arrow = showSortArrow;

    Object.keys(show_sort_arrow).forEach(obj_key => {
      if (obj_key === key)
        show_sort_arrow[obj_key] = true;
      else
        show_sort_arrow[obj_key] = false;
    })
    setShowSortArrow(show_sort_arrow);

    // let sort_key = dataFromNestedKeys(key)

    let arrayCopy = [...rows];
    // arrayCopy.sort(compareBy(key, sortDirection[key]));

    if (sortDirection[key] === "asc")
      arrayCopy = sorter.sort(arrayCopy).asc(key);
    else
      arrayCopy = sorter.sort(arrayCopy).desc(key);

    setRows(arrayCopy);
    // this.setState({rows: arrayCopy});

    let sort_direction = sortDirection;
    if (sort_direction[key] === 'asc')
      sort_direction[key] = 'desc';
    else if (sort_direction[key] === 'desc')
      sort_direction[key] = 'asc';
    setSortDirection(sort_direction);
  };

  const createTableCol = () => {
    return (
      allColumns.map((value, i) => {
        if (value?.format?.type !== 'rowCollasible') {
          let style_icon = { color: '#fff' };
          let arrow_direction = 'down';
          let className_cell_value = ''

          if (value?.sort && showSortArrow[value?.dataField])
            style_icon.display = 'inline';
          else
            style_icon.display = 'none';

          if (sortDirection[value?.dataField] === 'asc')
            arrow_direction = 'down';
          else if (sortDirection[value?.dataField] === 'desc')
            arrow_direction = 'up';

          if (value?.dataField === 'image')
            className_cell_value = 'data_table_cell_value_image';
          else
            className_cell_value = 'data_table_cell_value';

          return (
            <th data-field={value?.dataField} data-sort="desc" key={i}
              className="datatable-cell datatable-cell-sort data_table_cell data_table_th"
              onClick={() => { value?.sort === true && onClickSortCol(value?.dataField) }}
              colSpan={1} rowSpan={1} style={value?.format?.thStyle}
            >
              <span className={`${className_cell_value} data_table_th_value`} style={value?.format?.style}>
                {value?.text}
                <i className={`flaticon2-arrow-${arrow_direction} icon-nm ml-1`} style={style_icon}>
                </i>
              </span>
            </th>
          )
        }
      })
    )
  };

  useEffect(() => {
    if (contestUsers && contestUsers?.data?.length > 0) {
      setRows(contestUsers?.data);
      setTotalRecord(contestUsers?.totalRecord);

      let temp = { ...collasibleRowData };
      for (let i = 0; i < contestUsers.data.length; i++) {
        temp[contestUsers.data[i].phone] = contestUsers.data[i].teamDetails;
      }
      setCollasibleRowData(temp);
    }
  }, [contestUsers]);

  const getCountries = ({ item }) => {
    let countrues = item?.countriesAry || [];
    let str;
    if (countrues.length > 0) {
      // countrues.map((valC, ind) => {
      //   if (ind == 0) {
      //     str = valC.label
      //   } else {
      //     str = str + " , " + valC.label
      //   }
      // })
    } else {
      str = "-"
    }
    return (
      <span>{str}</span>
    );
  };

  return (
    <>
      <TournamentSummeryDetails type={"team"} />

      <div className="row">
        <div className="col-md-12">
          <Card className="card_border">
            <NotificationContainer />
            <div className="card-header p-0">
              <div className="my-5 row mx-0 px-4 w-100 d-flex justify-content-between">
                <div className="" style={{ fontSize: '24px', fontWeight: '600' }}>User's List</div>
              </div>
            </div>

            <CardBody className="p-0 w-100">
              {/* {
                      <table className="table dataTable datatable-table contest_data_table_table datatable-subtable w-100" style={{ display: 'block', }}>
                        <thead className="datatable-head data_table_head w-100">
                          <tr className="datatable-row" style={{ left: '0px', }}>
                            {createTableCol()}
                          </tr>
                        </thead>
    
                        <tbody className="datatable-body data_table_body w-100">
                          {
                            rows.map((value, i) => {
                              var backgroundColor = '#000';
                              if (value?.isRejected) {
                                backgroundColor = `#F64E60`;
                              } else if(value?.isAccepted){
                                backgroundColor = `#228C22`;
                              }

                              return (
                                <tr data-row={value?._id} className="datatable-row data_table_tr" style={{ left: '0px', color: backgroundColor }} key={i}>
                                  <td className="datatable-cell data_table_cell">
                                    <span className="data_table_cell_value">{i+1}</span>
                                  </td>
                                  <td className="datatable-cell data_table_cell">
                                    <span className="data_table_cell_value">{value?.playerName}</span>
                                  </td>
                                  <td className="datatable-cell data_table_cell">
                                    <span className="data_table_cell_value">
                                      {value?.teamDetails && value?.teamDetails.length > 0 ?
                                        <>
                                            <tr>
                                                <th>In Game Name</th>
                                                <th>User Name</th>
                                            </tr>
                                            {value.teamDetails.map((teamValue) =>
                                                <tr>
                                                    <td>
                                                      {teamValue?.playerInGameName}
                                                    </td>
                                                    <td>{teamValue?.user_saas_id}</td>
                                                </tr>
                                            )}
                                        </>
                                        :
                                        <></>
                                      }
                                    </span>
                                  </td>
                                  <td className="datatable-cell data_table_cell">
                                    <span className="data_table_cell_value">{value?.email}</span>
                                  </td>
                                  <td className="datatable-cell data_table_cell">
                                    <span className="data_table_cell_value">{value?.userData?.phone}</span>
                                  </td>
                                  <td className="datatable-cell data_table_cell">
                                    <span className="data_table_cell_value">
                                      { value?.isRejected !== false && value?.isRejected !== "false" ? "Rejected" : "" }
                                      { value?.isAccepted !== false && value?.isAccepted !== "false" ? "Accpeted" : "" }
                                      { value?.isRejected === false && value?.isAccepted === false ? "-" : "" }
                                    </span>
                                  </td>
                                  <td className="datatable-cell data_table_cell">
                                    <span className="data_table_cell_value">{value?.acceptedDate ? columnFormatters.dateTimeFormatCol(value?.acceptedDate) : "-"}</span>
                                  </td>
                                  <td className="datatable-cell data_table_cell">
                                    <span className="data_table_cell_value">{value?.rejectedDate ? columnFormatters.dateTimeFormatCol(value?.rejectedDate) : "-"}</span>
                                  </td>
                                  <td className="datatable-cell data_table_cell">
                                    <span className="data_table_cell_value">{columnFormatters.dateFormatCol(value?.createdAt)}</span>
                                  </td>
                                  <td className="datatable-cell data_table_cell">
                                    <span className="data_table_cell_value">{columnFormatters.timeFormatCol(value?.createdAt)}</span>
                                  </td>
                                  <td className="datatable-cell data_table_cell">
                                    { value?.isAccepted !== false && value?.isAccepted !== "false" ?
                                      <>
                                      </>
                                      : <>
                                        <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Accept Item</Tooltip>}>
                                          <a className="btn btn-icon btn-light btn-hover-success btn-sm mx-3" onClick={() => viewItem(value._id)}>
                                            <span className="svg-icon svg-icon-md svg-icon-success">
                                              <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
                                                <defs></defs>
                                                <g id="Stockholm-icons-/-General-/-Like" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                  <rect id="bound" x="0" y="0" width="24" height="24"></rect>
                                                  <path d="M9,10 L9,19 L10.1525987,19.3841996 C11.3761964,19.7920655 12.6575468,20 13.9473319,20 L17.5405883,20 C18.9706314,20 20.2018758,18.990621 20.4823303,17.5883484 L21.231529,13.8423552 C21.5564648,12.217676 20.5028146,10.6372006 18.8781353,10.3122648 C18.6189212,10.260422 18.353992,10.2430672 18.0902299,10.2606513 L14.5,10.5 L14.8641964,6.49383981 C14.9326895,5.74041495 14.3774427,5.07411874 13.6240179,5.00562558 C13.5827848,5.00187712 13.5414031,5 13.5,5 L13.5,5 C12.5694044,5 11.7070439,5.48826024 11.2282564,6.28623939 L9,10 Z" id="Path-42" fill="#000000"></path>
                                                  <rect id="Rectangle-153" fill="#000000" opacity="0.3" x="2" y="9" width="5" height="11" rx="1">
                                                  </rect>
                                                </g>
                                              </svg>
                                            </span>
                                          </a>
                                        </OverlayTrigger>
                                      </> }
                                      { value?.isRejected !== false && value?.isRejected !== "false" ?
                                      <>
                                      </>
                                      : <>
                                        <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Reject User</Tooltip>} >
                                          <a className="btn btn-icon btn-light btn-hover-danger btn-sm mx-3" onClick={() => deleteItem(value._id)} >
                                            <span className="svg-icon svg-icon-md svg-icon-danger">
                                              <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" style={{transform: `rotateX(180deg)`}}><defs></defs><g id="Stockholm-icons-/-General-/-Like" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><rect id="bound" x="0" y="0" width="24" height="24"></rect><path d="M9,10 L9,19 L10.1525987,19.3841996 C11.3761964,19.7920655 12.6575468,20 13.9473319,20 L17.5405883,20 C18.9706314,20 20.2018758,18.990621 20.4823303,17.5883484 L21.231529,13.8423552 C21.5564648,12.217676 20.5028146,10.6372006 18.8781353,10.3122648 C18.6189212,10.260422 18.353992,10.2430672 18.0902299,10.2606513 L14.5,10.5 L14.8641964,6.49383981 C14.9326895,5.74041495 14.3774427,5.07411874 13.6240179,5.00562558 C13.5827848,5.00187712 13.5414031,5 13.5,5 L13.5,5 C12.5694044,5 11.7070439,5.48826024 11.2282564,6.28623939 L9,10 Z" id="Path-42" fill="#000000"></path><rect id="Rectangle-153" fill="#000000" opacity="0.3" x="2" y="9" width="5" height="11" rx="1"></rect></g></svg>
                                            </span>
                                          </a>
                                        </OverlayTrigger>
                                      </>
                                    }
                                  </td>
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      </table>
                    } */}
                {
                  rows.length === 0 ?
                  <div className="row my-4 w-100 justify-content-center align-items-center" style={{ fontSize: '20px', fontWeight: '600', }}>
                    No user joined
                  </div>
                    :
                    <DataTable
                    rows={rows ? rows : []}
                    columns={allColumns}
                    isCollapsibleTableData={true}
                    collasibleRowData={collasibleRowData}
                    paginantionTotalAmountOfData={totalRecord}
                    DataTablePaginationAPICall={DataTablePaginationAPICall}
                  />
                }
                    

              {/* <DataTable
                      rows={rows ? rows : []}
                      columns={columns}
                    /> */}
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
}

export default TournamentTeams;